"use client";
import { jsxs as h, jsx as a } from "react/jsx-runtime";
import { forwardRef as _, useState as b, createElement as P } from "react";
import S from "../../elements/ProductCard/ProductCard.js";
import { withCmsDataHandling as x } from "../../../handlers/withCmsDataHandling/withCmsDataHandling.js";
import C from "../../layout/Container/Container.js";
import { useLanguage as k, Carousel as v, Group as I, Button as N, sharedHandler as $ } from "@ingeniorforeningen/figurine-core";
import { productselectorDeliveryApiParser as j } from "./ProductSelector.helpers.js";
import '../../../assets/ProductSelector.css';const H = "_button_1m78l_2", w = "_grid_1m78l_10", z = "_card_1m78l_16", A = {
  button: H,
  grid: w,
  card: z
}, o = _(
  (n, c) => {
    const {
      cards: l,
      header: i,
      cta: s = {
        text: "Få tilbud",
        href: "https://tilbud.idaforsikring.dk/studieberegner"
      },
      ...m
    } = n, [t, d] = b([]), { language: u } = k(), p = (e) => {
      t.includes(e) ? d(t.filter((r) => r !== e)) : d([...t, e]);
    }, g = () => t.map((e) => `&${e}=1`).join(""), f = () => `${s.href}?sprog=${u}${g()}`, y = l.map((e, r) => /* @__PURE__ */ P(
      S,
      {
        style: { margin: "auto" },
        ...e,
        key: r,
        onChange: () => p(e.type),
        value: t.includes(e.type),
        "data-value": t.includes(e.type),
        "data-cy": e.type
      }
    ));
    return /* @__PURE__ */ h(C, { size: "xl", ref: c, ...m, children: [
      /* @__PURE__ */ a(
        v,
        {
          slideSize: "16.3125em",
          sectionHeader: i,
          variant: "dark",
          draggable: !0,
          align: "center",
          children: y
        }
      ),
      /* @__PURE__ */ a(I, { className: A.button, children: /* @__PURE__ */ a(
        N,
        {
          variant: "cta",
          href: f(),
          text: s.text,
          m: "auto",
          id: "cta",
          disabled: t.length <= 0
        }
      ) })
    ] });
  }
);
o.displayName = "ProductSelector";
const D = x({
  Component: $(o),
  deliveryApiParser: j
});
D.displayName = o.displayName;
export {
  A as P,
  o as _ProductSelector,
  D as default
};
